import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ClasseEnum, obterDescricaoEnum} from './classe.enum';
import {MSG_OBG_BENEFICIARIO, MSG_OBG_INFORME_ANEXO, MSG_OBG_NUM_PROCESSO_VALIDO} from '../../../../tools/Mensagens';
import {AplicarRegraCampos} from '../validators/aplicar-regra-campos';
import {CampoObrigatorio} from '../validators/campo-obrigatorio';
import {TelefoneComponent} from '../shared/telefone/telefone.component';
import {
  ParteInformacaoRequerenteComponent
} from '../shared/parte-informacao-requerente/parte-informacao-requerente.component';
import {FILE_UPLOADER} from '../../../../componentes/file-uploader/file-uploader.component';
import {JustificativaComponent} from '../shared/justificativa/justificativa.component';
import {CpeResponseDTO} from "../../../../componentes/cpe-operador/dto/CpeResponseDTO";

@Component({
  selector: 'app-desarquivamento-autos',
  templateUrl: './desarquivamento-autos.component.html',
  styleUrls: ['./desarquivamento-autos.component.css']
})
export class DesarquivamentoAutosComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() formulario: FormGroup;
  @Input() somenteLeitura: boolean = false;
  @Input() dados: CpeResponseDTO;
  @ViewChild(TelefoneComponent, {static: false}) telefoneComponent: TelefoneComponent;
  @ViewChild(ParteInformacaoRequerenteComponent, {static: false}) parteInformacaoRequerenteComponent: ParteInformacaoRequerenteComponent;
  @ViewChild(JustificativaComponent, {static: false}) justificativaComponent: JustificativaComponent;
  @ViewChild(FILE_UPLOADER, {static: false}) fileUploader: any;
  protected readonly obterDescricaoEnum = obterDescricaoEnum;
  protected processoPossuiErro = false;
  protected labelArquivo = 'Anexe o comprovante de pagamento da taxa de desarquivamento:';
  protected mostrarUpload = false;


  constructor(private fb: FormBuilder, private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    if(!this.somenteLeitura){
      this.getFormularioDesarquivamentoAutos().setControl('classe', new FormControl(''));
      this.getFormularioDesarquivamentoAutos().setControl('beneficiarioJusticaGratuita', new FormControl('', Validators.required));
      this.getFormularioDesarquivamentoAutos().addControl('arquivo', new FormArray([]));

      if (this.dados !== null && this.dados !== undefined) {
        this.getFormularioDesarquivamentoAutos().get('classe').setValue(this.dados.classe);
        this.getFormularioDesarquivamentoAutos().get('beneficiarioJusticaGratuita').setValue(this.dados.beneficiarioAssistenciaGratuita);

        if(this.dados.beneficiarioAssistenciaGratuita === 'não'){
          this.definirMostrarUploadArquivo(true);
        }

      }
    }
  }

  ngOnDestroy() {
    if (!this.somenteLeitura) {
      this.getFormularioDesarquivamentoAutos().removeControl('classe');
      this.getFormularioDesarquivamentoAutos().removeControl('beneficiarioJusticaGratuita');
      this.getFormularioDesarquivamentoAutos().removeControl('arquivo');
    }
  }


  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }


  validarFormulario() {
    this.getFormularioDesarquivamentoAutos().markAsTouched();
    this.validarInformacoesRequerente();
    this.validarTelefone();
    this.validarJustitificativa();

    const campos = [
      {control: 'numeroProcesso', mensagem: MSG_OBG_NUM_PROCESSO_VALIDO, regra: this.validarNumeroProcesso.bind(this)},
      {
        control: 'beneficiarioJusticaGratuita',
        mensagem: MSG_OBG_BENEFICIARIO,
        regra: this.validarBeneficiario.bind(this)
      },
    ];

    if (this.mostrarUpload) {
      this.validarEAplicarAlertaUploadArquivo();
    }
    AplicarRegraCampos.aplicar(campos, this.getFormularioDesarquivamentoAutos());
  }

  protected definirMostrarUploadArquivo(check: boolean) {
    this.mostrarUpload = check;
  }

  protected getFormularioDesarquivamentoAutos() {
    return this.formulario.get('desarquivamentoAutos') as FormGroup;
  }

  protected obterListaClassePorNumero(): number[] {
    return Object.values(ClasseEnum).filter(value => typeof value === 'number') as number[];
  }

  protected setProcessoPossuiErro($possui: boolean) {
    this.processoPossuiErro = $possui;
  }

  protected get arquivos(): FormArray {
    return this.getFormularioDesarquivamentoAutos().get('arquivo') as FormArray; // Método para acessar o FormArray
  }

  private validarNumeroProcesso(value: any): boolean {
    return value != null && value !== '' && !this.processoPossuiErro;
  }

  private validarBeneficiario(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }

  private validarTelefone() {
    if (this.telefoneComponent) {
      this.telefoneComponent.validarFormulario();
    }
  }

  private validarArquivo(value: any): boolean {
    return CampoObrigatorio.aplicarParaArray(value);
  }

  private validarInformacoesRequerente() {
    if (this.parteInformacaoRequerenteComponent) {
      this.parteInformacaoRequerenteComponent.validarFormulario();
    }
  }

  private validarJustitificativa() {
    if (this.justificativaComponent) {
      this.justificativaComponent.validarFormulario();
    }
  }

  private validarEAplicarAlertaUploadArquivo(): void {
    this.arquivos.clear();
    this.fileUploader.mapFilesBase64.forEach((value: any, key: any) => {
      this.arquivos.push(this.fb.group({
        nomeArquivo: key,
        conteudo: value
      }));
    });
    const valido = CampoObrigatorio.aplicarParaArray(this.arquivos.value);
    if (!valido) {
      this.getFormularioDesarquivamentoAutos().setErrors({ invalid: true });
      this.getFormularioDesarquivamentoAutos().markAsTouched();
      alert(MSG_OBG_INFORME_ANEXO);
    }
  }
}
